import axios from "axios";
import { defaultEndPointDetails, getValidTokenV3 } from "../utils/const.utils";

export function getCABNInformationForPublicUser(tokenContractAddress) {
  return axios.get(
    `${defaultEndPointDetails.baseUrl}/api/v1/currencies/cabn/list?search=${tokenContractAddress}&offset=0&limit=10&isPagination=false`
  );
}

export async function getCABNsList(cabnListParameters) {
  return axios.get(
    `${
      defaultEndPointDetails.baseUrl
    }/api/v1/currencies/cabn/bulk/list?search=${
      cabnListParameters.search ? cabnListParameters.search : ""
    }&isAllowedOnMultiSwap=true&network=${
      cabnListParameters.networkId ? cabnListParameters.networkId : ""
    }&offset=${
      cabnListParameters.offset ? cabnListParameters.offset : ""
    }&limit=${
      cabnListParameters.limit ? cabnListParameters.limit : ""
    }&isPagination=${
      cabnListParameters.isPagination ? cabnListParameters.isPagination : ""
    }&tokenContractAddress=${
      cabnListParameters.tokenContractAddress
        ? cabnListParameters.tokenContractAddress
        : ""
    }&chainId=${
      cabnListParameters.chainId ? cabnListParameters.chainId : ""
    }&priority=${
      cabnListParameters.priority ? cabnListParameters.priority : ""
    }`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
        Authorization: `Bearer ${await getValidTokenV3()}`,
      },
    }
  );
}

export function getVersionHistory() {
  return axios.get(`${defaultEndPointDetails.baseUrl}/api/v1/versionHistory/`);
}

export function getCrucibleFees(cabn, token) {
  return axios.get(
    `${defaultEndPointDetails.baseUrl}/api/v1/crucibleFees/${cabn}`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export async function createUserCustomCABN(data) {
  return axios.post(
    `${defaultEndPointDetails.baseUrl}/api/v1/community-member/multiSwap/cabns/create`,
    data,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
        Authorization: `Bearer ${await getValidTokenV3()}`,
      },
    }
  );
}
